import { InvoiceTaskActivity } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1940. 請求タスクアクティビティ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_activities
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const invoiceTaskActivities = (props: Props): Promise<InvoiceTaskActivity[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_activities`
  );
};

export const useInvoiceTaskActivities = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => invoiceTaskActivities(props)
  });
};

export const useInvoiceTaskActivitiesInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'sales_orders',
    props.sales_order_id,
    'invoice_tasks',
    props.task_id,
    'invoice_task_activities'
  ];
};
